import { aiAboutCardModule, essityAiModelCardModule } from './modules';

export const essityAiModelsCardsPlugin = [
  aiAboutCardModule,
  essityAiModelCardModule,
];
